module.exports = __webpack_public_path__ + "static/media/labsoft_logo_v1.9a353403.png";